import { AlertService } from './../service/alert.service';
import { AuthService } from './../service/auth.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  constructor(
    public auth:AuthService,
    public alertService:AlertService,
    private router: Router
  ) { }

  ngOnInit() {
    
  }

  googleLogin(){
    this.auth.googleLogin().then(()=>{
      
    })
    .catch(error=>{
      console.error("error", error);
      localStorage.removeItem('awaitRedirect');
      let errorMessage:string = "";
      //Error code reference
      //https://developers.google.com/android/reference/com/google/android/gms/common/api/CommonStatusCodes
      
      errorMessage= error.message;
      if(error.code=="auth/user-not-found") errorMessage="Email tidak terdaftar. <br>Silahkan register bila belum mempunyai akun.";
      if(error.code=="auth/wrong-password") errorMessage="Password atau Email tidak sesuai.";
      if(error.code=="auth/unauthorized-domain") errorMessage="This domain is not authorized to run this operation";
      if(error==7) errorMessage = "A network error occurred. Retrying should resolve the problem.";
        
      if(errorMessage !== "")
      {  this.alertService.presentMessage(errorMessage);}
      else{
        this.alertService.presentMessage(error);
      }

    });
  }

}
